export default {
  altitudePreview: {
    expandAltitudeChart: 'Rozbalit tabulku',
    altitude: 'Nadmořská výška'
  }
}
